import React from 'react';
import { connect } from 'react-redux';
import { isDirty } from 'redux-form';
import InfiniteScroll from 'react-infinite-scroller';

import {
  onClickRow,
  salesTypeRequest,
} from 'actions/businessLibrary/salesType';
import { askConfirmAction } from 'actions/confirm-action';
import styles from './List.css';

class List extends React.Component {
  render() {
    const { salesType, salesTypeDetail } = this.props;
    return (
      <div className={styles.wrapper}>
        <table className={styles['table-header']}>
          <thead>
            <tr>
              <th className={styles.name}>Name</th>
            </tr>
          </thead>
        </table>
        <div
          className={`${
            styles['table-content-wrapper']
          } sales-type-table-content-wrapper`}
        >
          <InfiniteScroll
            pageStart={1}
            loadMore={this._onReachBottom}
            hasMore={this._hasMore()}
            useWindow={false}
            threshold={10}
            initialLoad={false}
          >
            <table className={styles['table-content']}>
              <tbody>
                {salesType &&
                  salesType.map(sales => {
                    return (
                      <tr
                        key={sales.id}
                        className={`${
                          salesTypeDetail && sales.id === salesTypeDetail.id
                            ? styles.selected
                            : ''
                        }`}
                        onClick={() => this._onClickRow(sales)}
                      >
                        <td className={styles.name}>{sales.name}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </InfiniteScroll>
        </div>
      </div>
    );
  }

  _onReachBottom = () => {
    const { dispatch, currentPage, totalPage, salesType } = this.props;
    const params = {
      page: currentPage + 1,
      keyword: '',
      size: 50,
    };
    if (currentPage < totalPage) {
      dispatch(salesTypeRequest(params, salesType));
    }
  };

  _hasMore = () => {
    const { currentPage, totalPage } = this.props;
    return currentPage < totalPage;
  };

  _onClickRow = salesType => {
    const { isDirtySalesType } = this.props;
    if (isDirtySalesType) {
      this.props.dispatch(askConfirmAction(onClickRow(salesType)));
    } else {
      this.props.dispatch(onClickRow(salesType));
    }
  };
}

function mapStateToProps(state) {
  const {
    salesType,
    salesTypeMeta,
    salesTypeDetail,
  } = state.businessLibrary.salesTypeHub;
  const isDirtySalesType = isDirty('salesTypeHub')(state);
  return {
    salesType,
    currentPage: salesTypeMeta.current_page,
    totalPage: salesTypeMeta.total_pages,
    salesTypeDetail,
    isDirtySalesType,
  };
}

export default connect(mapStateToProps)(List);
